import React, { useRef, useState, KeyboardEvent } from "react";

import icon_search from "bodycodi/cmap/app/svg/icon_search.svg";
import remove from "bodycodi/cmap/app/img/remove.png";

type MemberSearchPopWrapProp = {
  fetchMembers: Function;
  setIsSearch: Function;
  setMember?: Function;
};

const MemberSearchPopWrap = ({ fetchMembers, setIsSearch, setMember }: MemberSearchPopWrapProp) => {
  const [reomve, setRemove] = useState<boolean>(false);
  const input = useRef<HTMLInputElement>(null);
  const inputWrap = useRef<HTMLDivElement>(null);

  const onKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
    const keyCode = e.which ? e.which : e.keyCode;
    if (keyCode === 13) {
      fetchMembers("search");
      setIsSearch(true);
      if (setMember) {
        setMember({});
      }
    }
  };

  const onClickRemove = () => {
    const input1 = input.current!;
    input1.value = "";
    setRemove(false);
    setIsSearch(false);
    fetchMembers("fetch", true);
  };

  const onFocus = () => {
    setRemove(true);
  };

  return (
    <div className="member-mngt-condition-wrap">
      <div className="member-mngt-search" ref={inputWrap}>
        <img className="icon" src={icon_search} />
        <input
          name="name"
          placeholder="회원님 이름, 전화번호 뒤 4자리로 검색"
          onKeyUp={onKeyUp}
          onFocus={onFocus}
          ref={input}
        />
        {reomve && <img className="remove" src={remove} onClick={onClickRemove} />}
      </div>
    </div>
  );
};

export default MemberSearchPopWrap;
